module.exports = __webpack_public_path__ + "static/media/pymes-bread.1420c2d3.svg";